import classNames from "classnames";
import styles from "./TextEditor.module.css";


export interface TextEditorPropsForContentBlocks {
  className?: string;
  data: string;
}

export const TextEditorForContentBlocks = ({
  data,
  className = "",
  ...props
}: TextEditorPropsForContentBlocks) => {

  return (
    <div
      className={classNames(styles.texteditor, "postcontent", className)}
      {...props}
    >
      <div dangerouslySetInnerHTML={{ __html: data }}></div>
    </div>
  );
};
